import { createContext, Fragment, createElement, useContext } from 'react';
import { Link } from '@tanstack/react-router';
import en from './home/en.json';
import de from './home/de.json';
import es from './home/es.json';
import fr from './home/fr.json';
import id from './home/id.json';
import it from './home/it.json';
import ja from './home/ja.json';
import pt from './home/pt.json';
import ru from './home/ru.json';
import tr from './home/tr.json';
import zh from './home/zh.json';

// Homepage copy per language. To add a language, add ./home/<code>.json
// (same shape as en.json) and list it here.
const homeStrings = { en, de, es, fr, id, it, ja, pt, ru, tr, zh };

export const DEFAULT_LOCALE = 'en';

export const locales = Object.values(homeStrings)
  .map((strings) => strings.locale)
  .sort((a, b) => (a.code === DEFAULT_LOCALE ? -1 : b.code === DEFAULT_LOCALE ? 1 : a.code.localeCompare(b.code)));

export const localeHomePath = (code) => (code === DEFAULT_LOCALE ? '/' : `/${code}`);

export const localeOgImage = (code) =>
  `/images/og/${code === DEFAULT_LOCALE ? 'home' : `home-${code}`}.png`;

const LocaleContext = createContext(DEFAULT_LOCALE);

export const LocaleProvider = LocaleContext.Provider;

export const useLocale = () => useContext(LocaleContext);

export const useHomeStrings = () => homeStrings[useLocale()] || homeStrings[DEFAULT_LOCALE];

export const getHomeStrings = (code) => homeStrings[code] || homeStrings[DEFAULT_LOCALE];

const linkClass = 'text-accent hover:text-accent/80';

// Fills "{key}" placeholders in a translated string. Values can be plain strings,
// React elements, or { label, to } objects, which render as internal links.
export function fillTemplate(template, values = {}) {
  return template.split(/(\{\w+\})/).map((part, i) => {
    const match = part.match(/^\{(\w+)\}$/);
    if (!match || !(match[1] in values)) return createElement(Fragment, { key: i }, part);
    const value = values[match[1]];
    if (value && typeof value === 'object' && 'to' in value) {
      return createElement(Link, { key: i, to: value.to, className: linkClass }, value.label);
    }
    return createElement(Fragment, { key: i }, value);
  });
}
